"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Link = _interopRequireDefault(require("../../Link"));
var _fa = require("react-icons/fa6");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dependencies

class GroupList extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      subMenuOpen: false,
      subGroupLinks: {},
      height: 0
    };
  }
  handleLinkGroups(currId) {
    let subGroupLinks = this.state.subGroupLinks;

    // Prevents more than one sub-menu from displaying
    if (!subGroupLinks[currId]) {
      subGroupLinks[currId] = {
        subOpen: false
      };
    }
    for (let i in subGroupLinks) {
      if (subGroupLinks[i] !== subGroupLinks[currId]) {
        subGroupLinks[i] = {
          subOpen: false
        };
      } else {
        if (subGroupLinks[i] === subGroupLinks[currId] && subGroupLinks[i].subOpen === true) {
          subGroupLinks[i] = {
            subOpen: false
          };
        } else {
          subGroupLinks[i] = {
            subOpen: true
          };
        }
      }
    }
    this.setState({
      subGroupLinks
    });
  }
  buildList(list) {
    const listLen = list.length;
    let setClasses = '';
    let height = '';
    const subMenuHeight = {};
    height = 42 * this.props.list.length + 'px';
    subMenuHeight.maxHeight = height;
    return list.map((link, i) => {
      if (listLen === i + 1 && link.classes !== 'call-out') {
        if (link.classes) {
          setClasses = `${link.classes} group-list-item last-menu-item`;
        } else {
          setClasses = 'group-list-item last-menu-item';
        }
      } else {
        if (link.classes) {
          setClasses = `${link.classes} group-list-item`;
        } else {
          setClasses = 'group-list-item one';
        }
      }
      return /*#__PURE__*/_react.default.createElement("li", {
        key: i,
        className: setClasses,
        style: {
          // margin: link.classes === 'call-out' ? '20px 0' : '0',
          padding: '0',
          fontWeight: '300',
          textTransform: !this.props.isMobile && link.classes === 'call-out' ? 'uppercase' : 'none',
          color: link.classes === 'call-out' ? '#f0ab00' : '#fff',
          textAlign: this.props.isMobile ? 'left' : '',
          borderBottom: link.classes === 'call-out' && this.props.isMobile ? '3px solid #222' : 'none'
        }
      }, /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: link.classes === 'sub-menu' ? '' : link.src ? link.src : '',
        style: {
          color: 'inherit',
          fontSize: '14px',
          textDecoration: link.classes === 'sub-menu' || link.classes === 'call-out' ? 'none' : 'underline',
          transition: 'background-color 0.2s color 0.2s ease-in-out',
          padding: this.props.isMobile ? '5px 10px' : '10px 10px 10px 15px',
          display: 'block',
          cursor: 'pointer',
          margin: this.props.isMobile && link.classes === 'call-out' ? '30px 0' : '',
          borderBottom: link.classes === 'call-out' && this.props.isMobile ? '3px solid red' : 'none'
        },
        hoverStyles: {
          color: this.props.isMobile ? '#fff' : link.classes === 'call-out' ? '#000' : '#fff',
          backgroundColor: link.classes === 'call-out' ? '#f0ab00' : '#555555',
          fontWeight: '400'
        },
        list: link.subMenu ? link.subMenu : null,
        isMobile: this.props.isMobile,
        isSubGroupLink: true,
        handleLinkGroups: this.handleLinkGroups.bind(this),
        subLinks: this.state.subGroupLinks,
        height: this.state.height
      }, link.text, !this.props.isMobile && link.classes === 'sub-menu' ? /*#__PURE__*/_react.default.createElement(_fa.FaAngleRight, {
        size: 20,
        style: {
          float: 'right'
        },
        className: "fa-angle-right menu-arrow"
      }) : ''));
    });
  }
  componentDidMount() {
    this.getHeight();
  }
  componentDidUpdate() {
    this.getHeight();
  }
  getHeight() {
    if (this.state.height !== this.div.clientHeight) {
      this.setState({
        height: this.div.clientHeight
      });
    }
  }
  createListStyles() {
    // let height = this.props.listOpen ? (42 * this.props.list.length) + 'px' : '0';
    let height = '';
    if (this.props.isMobile && this.props.listOpen) {
      // Height is higher to account for the sub-menu items
      // TODO: Get exact exact height from design. There is a delay with closing the menu
      // beacuse it is detracting x amount of pixels from max height
      height = '1000px';
    } else if (this.props.listOpen) {
      height = 42 * this.props.list.length + 'px';
    } else if (!this.props.listOpen) {
      height = '0';
    }
    const listStyles = {
      overflow: this.props.isMobile ? 'hidden' : '',
      listStyle: 'none',
      background: this.props.isMobile ? 'transparent' : '#000',
      width: this.props.isMobile ? 'auto' : '200%',
      minWidth: this.props.isMobile ? 'auto' : '200px',
      position: this.props.isMobile ? 'static' : 'absolute',
      padding: !this.props.isMobile ? '0 0 40px 0' : 0,
      transition: 'all 0.25s ease-in-out',
      zIndex: '5'
    };
    if (!this.props.isMobile) {
      this.props.list.map(item => {
        if (item.subMenu) {
          // console.log('submenu', item.subMenu.length, 'listLength', this.props.list.length)
          if (item.subMenu.length > this.props.list.length) {
            height = 48 * item.subMenu.length + 'px';
            listStyles.height = height;
            // console.log(item.subMenu.length)
          }
        }
      });
    } else {
      listStyles.maxHeight = height;
    }
    return listStyles;
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("ul", {
      className: 'link-group-list' + (this.props.isMobile ? ' text-center' : ''),
      style: this.createListStyles(),
      id: "menu-group",
      ref: div => {
        this.div = div;
      }
    }, this.buildList(this.props.list)));
  }
}
exports.default = GroupList;
GroupList.propTypes = {
  list: _propTypes.default.array,
  listOpen: _propTypes.default.bool,
  isMobile: _propTypes.default.bool
};
GroupList.defaultProps = {
  list: []
};